var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketReachLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 33",
    width: 54,
    height: 50,
    rx: 6,
    fill: "#415896"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3758 28.4909L11 36.1515C11.5818 37.1212 12.3576 37.9939 13.2303 38.7697C14.103 39.6424 14.9758 40.3212 15.9455 41L23.703 30.7212",
    fill: "#F5BC41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1939 9C43.1939 9 30.2 9.09697 24.1879 19.5697C21.0848 18.697 20.1151 20.0545 20.1151 20.0545L15.7515 24.4182L21.0848 25C21.2788 25 21.4727 25.097 21.5697 25.2909C21.7636 25.4848 21.8606 25.7758 21.7636 26.0667C21.5697 26.8424 21.4727 27.6182 21.3758 28.4909L23.703 30.8182C24.5758 30.7212 25.3515 30.6242 26.1273 30.4303C26.4182 30.3333 26.7091 30.4303 26.903 30.6242C27 30.7212 27.097 30.9152 27.1939 31.1091L27.7758 36.3455L32.1394 31.9818C32.1394 31.9818 33.497 31.0121 32.6242 27.9091C43 21.9939 43.1939 9 43.1939 9ZM33.497 18.697C32.5273 17.7273 32.5273 16.2727 33.497 15.303C34.4667 14.3333 35.9212 14.3333 36.8909 15.303C37.8606 16.2727 37.8606 17.7273 36.8909 18.697C35.9212 19.6667 34.4667 19.6667 33.497 18.697Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketReachLogo);
export default __webpack_public_path__ + "static/media/RocketReachLogo.451e1157f4b7b816db10f70c4532dedc.svg";
export { ForwardRef as ReactComponent };